<template>
  <canvas ref="canvasRef" :style="sizeStyle" class="mx-auto xmov-qrcode"></canvas>
</template>

<script setup lang="ts" name="xQrcode">
import QRCode from 'qrcode';

const props = withDefaults(
  defineProps<{
    url: string;
    size?: number;
  }>(),
  {
    size: 150,
  },
);

const canvasRef = ref<HTMLCanvasElement | null>(null);

const sizeStyle = { width: `${props.size}px`, height: `${props.size}px` };

function genQrcode() {
  const canvas = canvasRef.value;
  if (!canvas) return;

  QRCode.toCanvas(
    canvas,
    props.url,
    {
      width: props.size,
      margin: 0,
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
    },
    () => {},
  );
}

watch(() => props.url, genQrcode);

onMounted(genQrcode);
</script>

<style lang="scss">
.xmov-qrcode {
  pointer-events: none;
  user-select: none;
}
</style>
